import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import { Urls } from "../../../utils/constant";

import { size, debounce } from "lodash";

import { minWidth } from "@mui/system";
import { useApi } from "../apiCall/useApi";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setAreaList } from "../../reducers/Area/area.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { setLeaveList } from "../../reducers/Leave/leave.reducer";

const COLUMN_LIST = [
  // { field: "customer_id", headerName: "ID", hide: true },
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "leave_type",
    headerName: "Leave Type",
    flex: 2,
  },
  {
    field: "status_val",
    headerName: "Status",
    flex: 1,
  },
];

const StatusList = [
  { id: 1, label: "active" },
  { id: 2, label: "In-Active" },
];

export default function useLeave() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [leaveType, setLeaveType] = useState("");
  const [status, setStatus] = useState(1);

  const fetchLeaveList = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const StatusVal = status === "All" ? 0 : status;
        const { data } = await apiPost({
          url: Urls.leaveGet(),
          data: {
            leave_type: leaveType,
            page_size: row_count,
            current_page: current_page,
            status: StatusVal,
          },
        });
        // setting list to reducer
        dispatch(setLeaveList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, status]
  );

  const handleLeaveTypeChange = useCallback((e) => {
    setLeaveType(e.target.value);
  }, []);

  const handleStatusChange = useCallback((e) => {
    setStatus(e.target.value);
  }, []);

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    status,
    StatusList,
    leaveType,
    handleLeaveTypeChange,
    handleStatusChange,
    fetchLeaveList,
  };
}
